import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

const cache = {};

export function useFetch(url, { cached = false } = {}) {
  const [data, setData] = useState(cached ? cache[url] : undefined);
  const [loading, setLoading] = useState(!data);
  const load = useCallback(() => {
    if (!url) return;
    setLoading(true);
    return api.get(url).then((r) => { cache[url] = r.data; setData(r.data); }).catch(() => setData(null)).finally(() => setLoading(false));
  }, [url]);
  useEffect(() => { load(); }, [load]);
  return { data, loading, reload: load, setData };
}

export const useContent = () => useFetch("/public/content", { cached: true }).data || {};
